function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 13"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#969EA2",
  fillRule: "evenodd",
  d: "M17.64 5.508c.48.605.48 1.38 0 1.984-1.3 1.624-4.31 4.675-8.64 4.675-4.33 0-7.34-3.05-8.64-4.675-.48-.605-.48-1.38 0-1.984C1.66 3.884 4.67.833 9 .833c4.33 0 7.34 3.05 8.64 4.675zM9 10.278c2.21 0 4-1.69 4-3.778 0-2.087-1.79-3.778-4-3.778S5 4.412 5 6.5c0 2.087 1.79 3.778 4 3.778zM9 4.61c1.104 0 2 .846 2 1.889 0 1.043-.896 1.889-2 1.889S7 7.543 7 6.5s.896-1.889 2-1.889z"
})));